import React from 'react'
import PropTypes from 'prop-types'

import VocabularyWordList from 'src/ui/VocabularyWordList/VocabularyWordList'

import VocabularyHeader from './subcomponents/VocabularyHeader/VocabularyHeader'
import UnitVocabularySkeleton from './UnitVocabularySkeleton'

const UnitVocabulary = ({ vocabularyList, studyVocabularyLink }) => {
  return (
    <UnitVocabularySkeleton
      headerSection={
        <VocabularyHeader studyVocabularyLink={studyVocabularyLink} />
      }
      listSection={<VocabularyWordList items={vocabularyList} />}
    />
  )
}

UnitVocabulary.propTypes = {
  studyVocabularyLink: PropTypes.string.isRequired,
  vocabularyList: PropTypes.arrayOf(PropTypes.object),
}

export default UnitVocabulary
